"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../../utils");
var __1 = require("..");
function default_1(projectElements, initialRun) {
    var series = [];
    if (projectElements) {
        series = projectElements.map(function (projectElement) {
            var projectOptions = {
                name: projectElement.props.name,
                borderWidth: 0,
                type: 'gantt'
            };
            var _a = projectElement.props, children = _a.children, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onShow = _a.onShow, onHide = _a.onHide;
            var tasks = utils_1.typeChildren(children).tasks;
            if (tasks) {
                projectOptions.data = tasks.map(function (task) { return __1.taskOptions(task); });
            }
            if (initialRun) {
                projectOptions.point = {
                    events: utils_1.bindEventHandlers({
                        onClick: onClick,
                        onMouseEnter: onMouseEnter,
                        onMouseLeave: onMouseLeave,
                        onShow: onShow,
                        onHide: onHide
                    })
                };
            }
            return projectOptions;
        });
    }
    return series;
}
exports.default = default_1;
//# sourceMappingURL=taskGroupOptions.js.map